<template>
    <div class="menus-top topbar-container">
        <WFGroupsMenu :showSubGroups="false" :currentGroup="searchVisible ? null : currentGroup" @clicked="click">
            <template v-slot:default="slotProps">
                <div class="flex group-content">
                    <WFIcon :name="groupIcon(slotProps.group.slug)"/><WFGroup :group="slotProps.group"></WFGroup>
                </div>
            </template>
            <template v-slot:append>
                <li class="wf-list-item search-btn" :class="{'active': searchVisible }" @click="showSearch">
                    <div class="group-content">
                        <WFIcon name="search"/><WFTranslate k="search"></WFTranslate>
                    </div>
                </li>
                <li class="wf-list-item menu-position" @click="showMenu"><WFIcon name="arrow"/></li>
            </template>
        </WFGroupsMenu>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {
        active: {
            type: String,
            default: ""
        },
        searchVisible: {
            type: Boolean,
            default: true
        },
        currentGroup: {
            type: Object,
            default: null
        }
    },
    computed: {
		...mapState('wf', ['landscape'])
	},
    methods: {
        groupIcon (slug) {
            return "group_"+slug;
        },
        showSearch () {
            this.$emit('search')
        },
        click (group) {
            this.$emit("clicked", group);
        },
        openTopics () {
            this.$emit('openTopics');
        },
        showMenu () {
            this.$emit('showMenu');
        }
    }
}
</script>

<style lang="less">
    @import '../css/variables';
    @import '../css/responsive';
    @import '../css/mixins';

    .menu-active .menu-position {
        background-color: var(--th-primary);

        svg {
            transform: rotate(0deg) !important;
            --icon_color: #000000 !important;
            fill: #000000 !important;
        }
    }

    .topbar-container {
        flex-basis: @top-bar-height;
        flex-shrink: 0;
        flex-grow: 0;
        transition: height 0.3s ease-out;
        
        .wf-groups-menu {
            padding: 0;
            
        }

        .search-btn {}

        .wf-list {
            display: flex;
            flex-direction: row;
            justify-content: stretch;

            .wf-list-item {
                margin-right: 0.6rem;
                flex-grow: 1;
                display: flex;
                justify-content: center;
                line-height: 1.7;
                height: 5.6rem;
                user-select: none;
                padding: 0;
                font-weight: bold;

                &.active svg, &.wf-active svg {
                    fill: var(--th-active-content);
                    --icon_color: var(--th-active-content);
                }

                .wf-item-content, .group-content {
                    display: flex;
                    align-items: center;
                }

                .group-content {
                    padding: 1.4rem 2.8rem;

                    .wf-group, label:not(.wf-name) {
                        padding-top: 0.3em;
                    }
                }

                

                .wf-name {
                    padding-top: 0.3rem;
                }

                span {
                    padding-top: 0.4rem;
                }

                svg {
                    height: 2.4rem;
                    fill: var(--th-primary);
                    margin-right: 0.6rem;
                }
            }

            .menu-position {
                flex-grow: 0;
                --icon_color: var(--th-primary);
                color: white;
                fill: #fff;
                border-radius: 50%;
                width: 5.6rem;
                height: 5.6rem;
                padding: 0;
                margin-right: 0;
                display: flex;
                align-items: center;
                transition: background-color 0.3s ease-out;
                
                svg {
                    width: 1.8rem;
                    margin-right: 0;
                    transform: rotate(180deg);
                    transition: transform 0.3s ease-out;
                }
            }
        }
    }

    .topbar-left-side {
        width: 33.5%;
        display: flex;
        align-items: center;
        padding-left: 1.4rem;

        
        & > * {
            border-right: 0.12rem solid @border-color;
            padding: 2rem;
            font-weight: 500;
        }
    }
    .topbar-right-side {
        flex-grow: 1;
    }
    .topbar-container {
        display: flex;

    }

    .search-input {
        border: 0.1rem solid @border-color;
        background-color: white;
        margin: 0.8rem;
        padding: 0.4rem;
        height: 4.8rem;
        width: auto;
        font-size: 1.8rem;
        font-weight: 500;
        margin: 0.8rem 2.4rem;
        overflow: hidden;
        display: flex;
        align-items: center;

        &.active {
            border: 0.1rem solid var(--th-active);
            .icon.close {
                opacity: 1;
            }

            .icon-search {
                --color1: var(--th-active);
            }
        }

        .icon.close {
            opacity: 0;
            margin-right: 2.4rem;
            transition: opacity 0.3s ease-out;
        }

        .icon-search {
            height: 1.8rem;
            margin-left: 2.4rem;
            margin-right: 0.8rem;
            transition: fill 0.3s ease-out;
        }

        input {
            width: 100%;
            height: 100%;
            border: 0;
            font-weight: 500;
            font-size: 1.8rem;
            margin-top: 0.1rem;
            color: @font-color;

            &:focus{
                outline: none;
            }
        }
    }
    .topbar-btn {
        font-size: 1.8rem;
        border: 0.2rem solid var(--th-primary);
        border-radius: 0.2rem;
        display: flex;
        align-items: center;
        position: relative;
        flex-grow: 1;
        flex-shrink: 1;
        overflow: hidden;
        height: 6.4rem;
        margin-right: 0.5rem;

        &::after {
            content: '';
            height: 0;
            transition: height 0.3s ease-out;
            width: 100%;
            position: absolute;
            bottom: 0;
            left: 0;
            background-color: var(--th-active);
        }

        .icon {
            height: 1.8rem;
            margin-right: 0.4rem;
            transition: --color1 0.3s ease-out;    
        }
        
        &.active .icon {
            --color1: var(--th-active);
        }

        &.active::after {
            height: 0.8rem;
        }
    }

    @media @portrait {
        .topbar-left-side {
            justify-content: stretch;
        }
    }

    @media @landscape {
        .topbar-container.search-visible {
            flex-basis: 8rem !important;
        }

        .topbar-right-side {
            height: 7.2rem;
            border-top: 0.2rem solid @border-color;

            .search-input {
                margin: 1.2rem 3.6rem;
                z-index: 1;
            }
        }
        .topbar-left-side {
            width: auto;
            height: 8rem;
            flex-basis: 8rem;
            flex-grow: 0;
            flex-shrink: 0;
            padding-left: 0;
            justify-content: space-between;
            flex-direction: row-reverse;
            box-shadow: 3px 16px 7px rgba(0, 0, 0, 0.01), 2px 9px 6px rgba(0, 0, 0, 0.04), 1px 4px 4px rgba(0, 0, 0, 0.07), 0px 1px 2px rgba(0, 0, 0, 0.08), 0px 0px 0px rgba(0, 0, 0, 0.08);
            z-index: 3;
            .up-shadow() !important;

            & > * {
                height: 100%;
                height: 100%;
                flex-grow: 1;
                justify-content: center;

                &:first-child {
                    border-right: none;
                }
            }
        }
    }
</style>